<template>
  <div class="online">
    <div class="contetn">
      <div class="newContetn">
        <div class="hander">
          <img class="results" src="./../../assets/treat/tiop.png" alt="" />
          诊疗思路考核
        </div>
        <div class="fenshu">
          <div class="pic">{{ onlineScore }}</div>
          <div class="pictxt">您的总成绩</div>
          <div class="pictxtall">(满分100分)</div>
          <div class="finish">已结束</div>
        </div>
      </div>
      <div class="footer">
        <div @click="handleBtn(true)" class="footerBox">评分规则</div>
        <div @click="handleBtn(false)" class="footerBox">答案详情</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSummaryScore } from "@/api/system/exam";
export default {
  data() {
    return {
      onlineScore: "",
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      getSummaryScore().then((res) => {
        if (res.data.code === 0) {
          this.onlineScore = res.data.data.petScore;
        }
      });
    },

    handleBtn(val) {
      if (val) {
        this.$router.push("/treat/grade");
      } else {
        this.$router.push("/treat/answer");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.online {
  width: 100%;
  min-height: 100vh;
  background-image: url("./../../assets/home/cbbj.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  .contetn {
    width: 653px;
    height: 1266px;
    background: rgba(255, 255, 255, 0.15);
    border: 2px solid #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 60px;
    margin-top: 91px;
    .newContetn {
      width: 496px;
      height: 856px;
      box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
      background: rgba(255, 255, 255, 0.65);
      border-radius: 60px;
      margin-top: 50px;
      .hander {
        width: 100%;
        height: 101px;
        display: flex;
        align-items: center;
        background: #5cb9ba;
        font-size: 36px;
        font-weight: 500;
        color: #333333;
        background: rgba(255, 255, 255, 0.8);
        box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
        border: 2px solid #ffffff;
        border-radius: 50px;
        padding: 0px 76px;
        box-sizing: border-box;
        opacity: 1;
        img {
          width: 47px;
          height: 71px;
          margin-right: 40px;
        }
      }
      .fenshu {
        display: flex;
        flex-direction: column;
        align-items: center;
        .pic {
          width: 375px;
          height: 375px;
          background: rgba(0, 173, 163, 0.7);
          border-radius: 50%;
          line-height: 375px;
          text-align: center;
          font-size: 157px;
          font-weight: bold;
          color: #ffffff;
          margin: 0 auto;
          margin-top: 40px;
        }
        .pictxt {
          margin-top: 28px;
          font-size: 30px;
          font-weight: 500;
          color: #333333;
          text-align: center;
        }
        .pictxtall {
          margin-bottom: 103px;
          font-size: 30px;
          font-weight: 500;
          color: #333333;
          text-align: center;
        }
        .finish {
          width: 339px;
          height: 69px;
          text-align: center;
          line-height: 69px;
          background: linear-gradient(
            132.74deg,
            rgba(0, 187, 177, 1) 0%,
            rgba(0, 86, 140, 1) 74.31%,
            rgba(171, 59, 127, 1) 100%
          );
          border: 1px solid #ffffff;
          box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
          border-radius: 34px;
          font-size: 35px;
          font-weight: 500;
          color: #ffffff;
        }
      }
    }
    .footer {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 48px;
      .footerBox {
        width: 496px;
        height: 66px;
        line-height: 66px;
        background: linear-gradient(
          132.74deg,
          rgba(0, 187, 177, 1) 0%,
          rgba(0, 86, 140, 1) 74.31%,
          rgba(171, 59, 127, 1) 100%
        );
        border: 1px solid #ffffff;
        box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
        opacity: 0.85;
        border-radius: 33px;
        font-size: 35px;
        font-weight: 500;
        color: #ffffff;
        text-align: center;
      }
      .footerBox:nth-child(2) {
        margin-top: 20px;
      }
    }
  }
}
</style>
